import { Button } from "@shopify/polaris"
import { observer } from "mobx-react"
import { XSmallIcon } from "polaris-enhance"
import React from "react"

import stores from "@/stores"

interface V6MarketingProps {
  type: "upgradeindashboard" | "upgradeinplan"
}
const V6MarketingBanner = (props: V6MarketingProps) => {
  const { type = "upgradeindashboard" } = props
  const { UserInfoStore } = stores

  const srcMap = {
    upgradeindashboard: {
      img: "https://return-cdn.parcelpanel.com/public/tinified/v6_banner_home.png",
      key: "index_upgrade",
      code: 26,
      onClick: () => {
        pnav("/billing")
      },
    },
    upgradeinplan: {
      img: "https://return-cdn.parcelpanel.com/public/tinified/v6_banner_billing.png",
      key: "billing_upgrade",
      code: 25,
    },
  }
  const bannerConfig = srcMap[type]
  async function onClose(e: React.MouseEvent) {
    e.preventDefault()
    e.stopPropagation()
    await UserInfoStore.closeBanner(bannerConfig.code, bannerConfig.key)
  }

  const handleClick = bannerConfig.onClick ?? undefined

  return (
    <div
      className={`relative group ${handleClick ? "cursor-pointer" : ""}`}
      onClick={handleClick}
    >
      <img src={bannerConfig.img} alt="" className="w-full hidden md:flex" />
      <img
        src={"https://return-cdn.parcelpanel.com/public/tinified/v6mbhome.png"}
        className="w-full flex md:hidden"
      />
      <div
        className="absolute top-3 right-3 opacity-0 group-hover:opacity-100"
        onClick={onClose}
      >
        <Button icon={XSmallIcon} variant="tertiary"></Button>
      </div>
    </div>
  )
}

export default observer(V6MarketingBanner)
